import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Logement } from '../models/logement.model';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_PATHS } from '../constants/api-paths';
import { jsonHttpHeaders } from '../constants/http-headers';

/**
 * Client HTTP des unités / logements ({@code /logements}).
 */
@Injectable({
  providedIn: 'root',
})
export class LogementService {
  constructor(private readonly http: HttpClient) {}

  /** Liste tous les logements. */
  getLogement(): Observable<Logement[]> {
    return this.http.get<Logement[]>(
      `${environment.apiUrl}${API_PATHS.logements}`
    );
  }

  /** Crée un logement ; renvoie l'id créé. */
  registerLogement(logement: Logement): Observable<string> {
    return this.http
      .post<Logement>(
        `${environment.apiUrl}${API_PATHS.logements}`,
        logement,
        { headers: jsonHttpHeaders() }
      )
      .pipe(map((response) => this.resolveLogementId(response)));
  }

  /** Met à jour un logement existant. */
  updateLogement(logement: Logement): Observable<Logement> {
    const id = this.resolveLogementId(logement);

    return this.http.put<Logement>(
      `${environment.apiUrl}${API_PATHS.logement(id)}`,
      logement,
      { headers: jsonHttpHeaders() }
    );
  }

  /** Détail d'un logement par id. */
  getLogementById(id: string): Observable<Logement> {
    return this.http.get<Logement>(
      `${environment.apiUrl}${API_PATHS.logement(id)}`
    );
  }

  /** Supprime un logement. */
  deleteLogement(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}${API_PATHS.logement(id)}`
    );
  }

  private resolveLogementId(logement: Pick<Logement, 'idLogementDto'>): string {
    return logement.idLogementDto ?? '';
  }
}
